(function(){
  const priceEls = document.querySelectorAll('.price');
  const measEls  = document.querySelectorAll('.measurement');
  const currencySelect = document.getElementById('currency-select');
  const unitSelect     = document.getElementById('unit-select');

  // Load preferences
  let currentCurrency = localStorage.getItem('currency') || Shopify.currency.active || currencySelect.value;
  let currentUnits    = localStorage.getItem('units')    || unitSelect.value;

  // Conversion rates (example; ideally fetch real rates via API)
  const currencyRates = { USD:1, EUR:0.85, GBP:0.75 };
  // Unit conversion factors
  const unitFactors = {
    cm_to_in: 0.393701,
    kg_to_lb: 2.20462,
    in_to_cm: 2.54,
    lb_to_kg: 0.453592
  };

  function updatePrices(){
    priceEls.forEach(el=>{
      const base = parseFloat(el.textContent.replace(/[^0-9\.]/g,'')); 
      const rate = currencyRates[currentCurrency] || 1;
      const converted = (base * rate).toFixed(2);
      el.textContent = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currentCurrency
      }).format(converted);
    });
  }

  function updateMeasurements(){
    measEls.forEach(el=>{
      const val = parseFloat(el.getAttribute('data-value'));
      const baseUnit = el.getAttribute('data-base-unit'); 
      let converted, display;
      if(currentUnits==='imperial'){
        if(baseUnit==='cm'){
          converted = (val * unitFactors.cm_to_in).toFixed(1);
          display = `${converted}in`;
        } else if(baseUnit==='kg'){
          converted = (val * unitFactors.kg_to_lb).toFixed(1);
          display = `${converted}lb`;
        }
      } else {
        if(baseUnit==='in'){
          converted = (val * unitFactors.in_to_cm).toFixed(1);
          display = `${converted}cm`;
        } else if(baseUnit==='lb'){
          converted = (val * unitFactors.lb_to_kg).toFixed(1);
          display = `${converted}kg`;
        }
      }
      el.textContent = display;
    });
  }

  // Handlers
  currencySelect.addEventListener('change', e=>{
    currentCurrency = e.target.value;
    localStorage.setItem('currency', currentCurrency);
    updatePrices();
  });
  unitSelect.addEventListener('change', e=>{
    currentUnits = e.target.value;
    localStorage.setItem('units', currentUnits);
    updateMeasurements();
  });

  // Init
  currencySelect.value = currentCurrency;
  unitSelect.value     = currentUnits;
  updatePrices();
  updateMeasurements();
})();
